import mercadoPagoLogo from '../assets/mercado-pago-logo.svg';
import './MercadoPagoLinkButton.css';

/** External Mercado Pago payment link styled with the Mercado Pago brand. */
const MercadoPagoLinkButton = ({ href, onClick, children, style }) => (
  <a
    className="btn mercado-pago-link-button"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={onClick}
    style={style}
  >
    <img src={mercadoPagoLogo} alt="" aria-hidden="true" className="mercado-pago-link-button__logo" />
    {children}
  </a>
);

export default MercadoPagoLinkButton;
